import React, { useLayoutEffect, useRef, useState } from "react";

interface CollapsibleTextProps {
  text: string | React.ReactNode;
  height?: number;
  showMoreClassName?: string;
  showAsHTML?: boolean;
}

const CollapsibleText: React.FC<CollapsibleTextProps> = ({
  text,
  height = 108,
  showMoreClassName = "text-sm text-orange font-medium",
  showAsHTML,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const showMoreRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    showMoreRef && setContentHeight(showMoreRef.current?.scrollHeight || 0);
  }, [text]);

  return (
    <div>
      <div
        ref={showMoreRef}
        className={`overflow-hidden ${
          showAsHTML && typeof text === "string" && "html-content"
        } text-text leading-6 whitespace-pre-line`}
        style={{
          ...(expanded
            ? {
                height: "auto",
              }
            : { maxHeight: height }),
        }}
        {...(showAsHTML && typeof text === "string"
          ? {
              dangerouslySetInnerHTML: { __html: text },
            }
          : { children: text })}
      ></div>
      {contentHeight > height && (
        <button
          className={`${showMoreClassName} focus:outline-none`}
          onClick={() => setExpanded((v) => !v)}
        >
          Show {expanded ? "less" : "more"}
        </button>
      )}
    </div>
  );
};

export default CollapsibleText;
